import debug from 'debug';
import host from './host';

import { langAction, visitAction } from 'sdi/activity';
import { getApiUrl, getLang, loop } from 'sdi/app';
import { DIV, NodeOrOptional } from 'sdi/components/elements';
import tr from 'sdi/locale';

import { activityLogger } from './events/app';
import { loadAlias, loadAllBaseLayers } from './events/data';
import { loadMapFromRoute } from './events/map-info';
import { loadAllServices } from 'sdi/geocoder/events';
import feature from './components/feature-view';
import legend from './components/legend';
import map from './components/map';
import { getEmbedProfile, getLayout, withMobile } from './queries/app';

const logger = debug('sdi:app');

const logo = () => DIV('brand-logo', DIV('brand-name'));

const wrappedMain = (...elements: NodeOrOptional[]) =>
    DIV(
        `app-inner embed profile-${getEmbedProfile()} ${withMobile()
            .map(() => 'mobile')
            .getOrElse('desktop')}`,
        DIV('main', ...elements),
        logo(),
    );

const render = () => {
    const layout = getLayout();
    const profile = getEmbedProfile();
    switch (layout) {
        case 'map':
            switch (profile) {
                case 'full-screen':
                    return wrappedMain(map());
                default:
                    return wrappedMain(map(), legend());
            }

        case 'map-and-feature':
            return wrappedMain(map(), feature());
    }
};

const effects = () => {
    loadAllServices()
        .then(() => loadAllBaseLayers(getApiUrl(`wmslayers/`)))
        .then(loadMapFromRoute)
        .finally(host);
    loadAlias(getApiUrl('alias'));
    tr.init_edited();
    activityLogger(visitAction());
    activityLogger(langAction(getLang()));
};

const app = loop('embed-app', render, effects);
export default app;

logger('loaded');
